import moment from "moment";

/**
 * Function to retrieve cut off date for meal plans
 *
 * @param {Object} systemConfig 
 * @returns Object
 */
export const getCutOffDate = systemConfig => {
  const {mealordering_cutoff_day, mealordering_cutoff_time} = systemConfig;
  const today = moment();

  // Meal Ordering Cutoff
  if (mealordering_cutoff_day !== "") {
    const start_of_next_week = moment().add(1, "week").startOf("week").add(1, "day");
    const start_of_following_week = start_of_next_week.clone().add(1, "week");
    const cutoff_date = moment(today.clone().startOf("week").add(mealordering_cutoff_day, "day").format("YYYY-MM-DD") + " " + mealordering_cutoff_time);

    //check if we need to push a week further ahead
    return today.isBefore(cutoff_date) ? start_of_next_week : start_of_following_week;
  }

  return today;
}